import { TinyColor, mostReadable } from '@ctrl/tinycolor';

/**
 * Generate state variants for colors of buttons and button-like components
 *
 * @param {ColorKind} kind The color variant
 * @param {Theme} theme The active theme
 * @param {GenerateColorLuminanceOptions} options Colors to be used instead of the theme colors
 */

var generateColorLuminances = function generateColorLuminances(kind, theme, options) {
  var _ref = options || {},
    _ref$color = _ref.color,
    color = _ref$color === undefined ? theme.colors.primary : _ref$color,
    textColor = _ref.textColor,
    _ref$disabledColor = _ref.disabledColor,
    disabledColor = _ref$disabledColor === undefined ? theme.tokens.button.disabled : _ref$disabledColor;
  var textColors = [theme.colors.text, theme.colors.background];
  var base = new TinyColor(kind === 'disabled' ? disabledColor : color);
  var _theme$button$web = theme.button.web,
    hoverLuminance = _theme$button$web.hoverLuminance,
    activeLuminance = _theme$button$web.activeLuminance;
  var hslLuminance = base.toHsl().l;
  var transformedActiveLuminance = hslLuminance + activeLuminance / 100;
  return {
    get bg() {
      switch (kind) {
        case 'normal':
        case 'disabled':
          return base.toHexString();
        case 'focus':
        case 'hover':
          if (transformedActiveLuminance < 0 || hoverLuminance > 0) {
            return base.lighten(Math.abs(hoverLuminance)).toHexString();
          } else {
            return base.darken(Math.abs(hoverLuminance)).toHexString();
          }
        case 'click':
          if (transformedActiveLuminance < 0 || activeLuminance > 0) {
            return base.lighten(Math.abs(activeLuminance)).toHexString();
          } else {
            return base.darken(Math.abs(activeLuminance)).toHexString();
          }
      }
    },
    get fg() {
      var _mostReadable;
      if (kind === 'disabled') return theme.tokens.text.disabled;
      // This previously had darken(20), I guess the reason was to have white text on optimisticGreen background
      // Removed the darkening as on dark theme we want to actually use the better contrast case
      // istanbul ignore next
      var text = textColor || ((_mostReadable = mostReadable(base, textColors)) === null || _mostReadable === undefined ? undefined : _mostReadable.toHexString()) || new TinyColor(textColors[0]).toHexString();
      return text;
    }
  };
};

export { generateColorLuminances };
